// redux/slices/relatedProductsSlice.js

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";
import { createSelector } from "@reduxjs/toolkit";

const BASE_URL = "https://moga-dev.com/api";

export const fetchRelatedProductsByCategory = createAsyncThunk(
  "relatedProducts/fetchRelatedProductsByCategory",
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/products/category/${categoryId}`);
      let relatedProducts = response.data.data || [];

      // Shuffle and take 10 random
      relatedProducts = relatedProducts.sort(() => 0.5 - Math.random()).slice(0, 10);

      return { categoryId, relatedProducts };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch related products");
    }
  }
);

const relatedProductsSlice = createSlice({
  name: "relatedProducts",
  initialState: {
    relatedProducts: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRelatedProductsByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRelatedProductsByCategory.fulfilled, (state, action) => {
        const { categoryId, relatedProducts } = action.payload;
        state.loading = false;
        state.relatedProducts[categoryId] = relatedProducts;
      })
      .addCase(fetchRelatedProductsByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectRelatedProductsByCategory = createSelector(
  [(state) => state.relatedProducts.relatedProducts, (_, categoryId) => categoryId],
  (relatedProducts, categoryId) => relatedProducts[categoryId] || []
);
export const selectRelatedProductsLoading = (state) =>
  state.relatedProducts.loading;

export const selectRelatedProductsError = (state) =>
  state.relatedProducts.error;

export default relatedProductsSlice.reducer;
